import * as Yup from 'yup';
export const addcategoryvideo_validationSchema = Yup.object({
    VideoUrl: Yup.string().required("Please Enter Video url")
  });